exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#post-list>div[data-v-5875b802]:nth-child(3n+1),#post-list>div[data-v-5875b802]:nth-child(4n+1){grid-column:span 2}", ""]);

// exports
